import getContactNumberValidationFunctions
from '../components/address/field-validation/getContactNumberValidationFunctions';
import {getIsMobileNumber} from '../selectors/ContactNumberSelectors';
import getContactNumberMaxLength from '../selectors/ContactNumberValidationSelectors/getContactNumberMaxLength';
import getContactNumberMinLength from '../selectors/ContactNumberValidationSelectors/getContactNumberMinLength';
import getRegexValidation from '../selectors/ContactNumberValidationSelectors/getRegexValidation';
import {getSelectedContactNumber, selectIsContactNumberRequired} from '../selectors/selectors';

const getIsContactNumberIsNotValid = (state) => {
  const contactNumber = getSelectedContactNumber(state);
  
  const contactNumberProps = {
    isMobileNumber: getIsMobileNumber(state),
    isRequired: selectIsContactNumberRequired(state),
    minLength: getContactNumberMinLength(state),
    maxLength: getContactNumberMaxLength(state),
    regexValidation: getRegexValidation(state),
  };
  
  const contactNumberValidationFunctions = getContactNumberValidationFunctions(contactNumberProps);
  
  const contactNumberErrors = contactNumberValidationFunctions
    .map(validate => validate(contactNumber))
    .filter(result => result !== undefined);
  
  return contactNumberErrors.length !== 0;
};

export default getIsContactNumberIsNotValid;
